import API from './API.js';
import axios from 'axios'
export default class Menu extends API {
    constructor() {
        super('menu-item');
    }

    async updatePriority(data, headers = {}) {
        try {
          const response = await axios.post('update_priority', data, headers);
          return response.data
        } catch (error) {
          if (error.response) {
            console.log(error.response.data.message); // => the response payload 
          }
        }
      }
    async menu(params) {
        try {
          const response = await axios.get('menu_list', { params });
          return response.data
        } catch (error) {
          if (error.response) {
            console.log(error.response.data.message); // => the response payload 
          }
        }
      }
    async updateMenu(data, headers = {}) {
        try {
          const response = await axios.post('update_menu', data, headers);
          return response.data
        } catch (error) {
          if (error.response) {
            console.log(error.response.data.message); // => the response payload 
          }
        }
      }
}
